import { motion } from "framer-motion"

const LOGO_SRC = "https://static.lumi.new/22/227f5e34337577810a83d76c81dac150.webp"

function About() {
  return (
    <section
      id="about"
      className="relative flex min-h-screen w-full flex-col justify-center bg-black px-8 py-28 md:px-16 md:py-40 lg:px-28"
    >
      <motion.p
        className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 1 }}
      >
        02
      </motion.p>

      <motion.div
        className="mt-8 flex justify-center md:mt-10"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 1.1, delay: 0.1 }}
      >
        <img
          src={LOGO_SRC}
          alt="AROMA IDOL"
          className="h-auto w-full max-w-2xl object-contain md:max-w-4xl"
        />
      </motion.div>

      <div className="mt-16 flex w-full flex-col items-center gap-12 md:mt-24 md:gap-10">
        <motion.p
          className="font-serif-tc mx-auto max-w-2xl text-center text-sm leading-relaxed text-stone-200 sm:text-base"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2 }}
        >
          我們希望 Aroma Idol 不只是一場調香比賽，
          <br className="md:hidden" />
          而是一個讓氣味創作者被看見的舞台。
        </motion.p>

        <motion.p
          className="font-sans-ui mx-auto max-w-xs text-center text-[11px] leading-6 tracking-wide text-stone-400 md:max-w-none md:text-sm md:leading-8"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2, delay: 0.15 }}
        >
          <span className="md:hidden">
            這不是一瓶被製造出來的香水，而是一位音樂創作者，
            <br />
            寫給嗅覺的下一首作品。
          </span>
          <span className="hidden whitespace-nowrap md:inline">
            這不是一瓶被製造出來的香水，而是一位音樂創作者，寫給嗅覺的下一首作品。
          </span>
        </motion.p>
      </div>
    </section>
  )
}

export default About
